import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { getCountryCode } from "helpers/getCountryCode";
import { useMindlerApi } from "./apiv2";

export const useAppConfig = () => {
  const api = useMindlerApi();
  const { data, isPending } = useQuery(
    api.application.config.queryOptions(
      {
        platform: "web",
        countryCode: getCountryCode(),
      },
      {
        staleTime: Infinity, // We only refetch if we logout or switch market which is invalidated elsewhere
      },
    ),
  );
  return { config: data, isLoading: isPending };
};
